import {
    DataSourceExecutionEvent, LayoutProvidedCrudDecoratorProps, DataSourceModeChangeEvent, DataSourceMode
} from "@mcleod/components";
import { AutogenLayoutUser } from "./autogen/AutogenLayoutUser";
import { UserUtil } from "./UserUtil";

export class User extends AutogenLayoutUser {
    override onLoad() {
        UserUtil.setAdminComponentVisibility(this.panelAdminButtons);
        // We currently only offer the change web password and copy user functions in //web
        this.buttonSetWebPassword.visible = false;
        this.buttonCopyUser.visible = false;
        UserUtil.handleScrollToTab(this, this.tabsetUsers);
    }

    sourceUserSettingsAfterExecution(event: DataSourceExecutionEvent) {
        const userBeingUpdated = this.sourceUserSettings.activeRow.get("id");
        UserUtil.triggerSettingsRefresh(userBeingUpdated, this, event);
    }

    override get crudDecoratorProps(): LayoutProvidedCrudDecoratorProps {
        return UserUtil.getCrudDecoratorProps();
    }

    async buttonUserGroupsOnClick() {
        const userId = this.activeRow?.get("id", "") ?? "";
        const userName = this.activeRow?.get("name", "") ?? "";
        UserUtil.displayGroupMembership(userId, userName);
    }

    buttonSetWebPasswordOnClick() {
        // We currently only offer the change web password function in //web
        // const endpointPath = "common/user/change-web-password";
        // const userId = this.sourceUserSettings.activeRow.get("id", null);
        // const userName = this.sourceUserSettings.activeRow.get("name", null);
        // new WebPasswordChange(endpointPath, userId, userName).show();
    }

    buttonCopyUserOnClick() {
        // We currently only offer the change copy user function in //web
        // const endpointPath = "common/user/copy";
        // const sourceUserId = this.sourceUserSettings.activeRow.get("id", null);
        // const sourceUserName = this.sourceUserSettings.activeRow.get("name", null);
        // new CopyUser(endpointPath, sourceUserId, sourceUserName).fillAndShow();
    }

    sourceUserSettingsAfterModeChange(event: DataSourceModeChangeEvent) {
        const toolbarButtonsVisible = event.newMode === DataSourceMode.UPDATE;
        this.buttonUserGroups.visible = toolbarButtonsVisible;
        // this.buttonSetWebPassword.visible = toolbarButtonsVisible;
        // this.buttonCopyUser.visible = toolbarButtonsVisible;
    }
}
